/**
 * Use the CSS tab above to style your Element's container.
 */
import React from 'react';
import {CardElement} from 'react-stripe-elements';
import PaymentMethods from '../../../../../assets/img/payment_methods.jpg';

const style = {
    base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
            color: "#aab7c4"
        }
    },
    invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
    }
};

const CardSection = () => {
    return (
        <label className="card-payment-label-resp">
            <h2 className="text-center">
                カードで支払う
            </h2>
            <p className="card-payment-modal-content">
                カードの詳細に続いて、カード番号、有効期限、CVC、郵便番号を入力します。
            </p>
            <div className="payment-method-card-div-resp">
                サポートされている支払い方法
                <img src={PaymentMethods} className="payment-methods-card-payment-img" alt="Visa/Master Card/American Express/Discover/JCB/Diners Club/Union Pay"/>
            </div>
            <CardElement className="MyCardElement" style={style} />
        </label>
    );
};

export default CardSection;


// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderConfirmationBottom/StripeComponents/CardSection.js